export default __webpack_public_path__ + "static/media/KiaLanding.e863cb4f.svg";